import { FadeIn } from "@/components/site/FadeIn";
import { ABOUT, BOOK } from "@/data/book";

export const AboutBook = () => (
  <section
    id="about"
    data-testid="about-book-section"
    className="relative py-28 sm:py-36 overflow-hidden"
  >
    <img
      src={BOOK.hummingbird}
      alt=""
      aria-hidden="true"
      className="pointer-events-none select-none absolute -right-16 top-16 w-72 sm:w-96 opacity-[0.12] blend-multiply -rotate-6"
    />

    <div className="max-w-3xl mx-auto px-6 text-center">
      <FadeIn>
        <p
          data-testid="about-book-heading"
          className="text-xs uppercase tracking-[0.28em] text-[#2a7b76] font-semibold mb-6"
        >
          About the book
        </p>
        <p className="font-display text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.25] text-[#201c19] font-light">
          {ABOUT.lead}
        </p>
      </FadeIn>

      <FadeIn delay={0.15} className="mt-10 space-y-6">
        {ABOUT.body.map((p, i) => (
          <p
            key={p}
            data-testid={i === 0 ? "about-book-description" : undefined}
            className="text-lg text-stone-600 leading-relaxed font-light"
          >
            {p}
          </p>
        ))}
      </FadeIn>

      <FadeIn delay={0.25} className="mt-12 flex flex-wrap justify-center gap-3">
        {["Contemplative Poetry", "Healing & Growth", "Mind–Body Connection"].map((tag) => (
          <span
            key={tag}
            className="rounded-full border border-stone-300 bg-white/60 px-5 py-2 text-sm text-[#4b443e]"
          >
            {tag}
          </span>
        ))}
      </FadeIn>
    </div>
  </section>
);

export default AboutBook;
